import { lazy } from 'react'

export const KnowledgeBaseWrapperLazy = lazy(
  () => import('./KnowledgeBaseWrapper'),
)
